module.exports = __webpack_public_path__ + "static/media/breastlink.2657dbb8.jpg";